import { render, staticRenderFns } from "./ordersManagement.vue?vue&type=template&id=239fa072"
import script from "./ordersManagement.vue?vue&type=script&lang=js"
export * from "./ordersManagement.vue?vue&type=script&lang=js"
import style0 from "./ordersManagement.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports